import { GridColDef } from '@microservices/wiskey-react-table-component'
import { MobileListItem } from '@mobileTypes'

export const MOBILE_LIST_ITEMS_COLUMNS: GridColDef[] = [
  {
    field: 'internalId',
    headerName: 'Internal ID',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 200,
  },
]

export const DEFAULT_MOBILE_LIST_ITEM: Omit<MobileListItem, 'id' | 'createdAt' | 'updatedAt'> = {
  internalId: '',
  name: '',
  itemType: 'dictionary',
  // Validation requires at least one row in "simple" mode,
  // so new config starts with a single empty row.
  rows: [{ elements: [] }],
  getDataCommands: null,
  dataSource: {
    bindType: 'command',
  },
  configMode: 'simple',
  itemTemplate: undefined,
  variables: [],
  eventFlows: [],
  enableSearch: false,
  searchFields: [],
}
